import { type Domain, domains } from '@config'
import { useCallback } from 'react'

import { useDomainUrl } from './use-domain-url'

export const useGetDynamicDomainLink = (domainId: Domain) => {
  const domainUrl = useDomainUrl(domainId)
  return useCallback(
    (url: string) =>
      String(url).replace(domains[domainId].production, domainUrl),
    [domainUrl]
  )
}
